import type { FC } from "react";

import type { BaseIconProps } from "@/assets/icons/utils";

export const IconCalendar: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect x="2.5" y="3.5" width="11" height="10" rx="1.5" stroke="currentColor" strokeWidth="1.2" />
                    <path d="M2.5 6.5H13.5" stroke="currentColor" strokeWidth="1.2" />
                    <path d="M5.5 2V4.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                    <path d="M10.5 2V4.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect x="3" y="4" width="14" height="13" rx="2" stroke="currentColor" strokeWidth="1.3" />
                    <path d="M3 8H17" stroke="currentColor" strokeWidth="1.3" />
                    <path d="M7 2.5V5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
                    <path d="M13 2.5V5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect x="3" y="4" width="18" height="17" rx="2" stroke="currentColor" strokeWidth="1.4" />
                    <path d="M3 9H21" stroke="currentColor" strokeWidth="1.4" />
                    <path d="M8 2.5V5.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                    <path d="M16 2.5V5.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                </svg>
            );
    }
};
